<template>
    <div :class="['completed-pr-container', { 'not-complete': !isfinalPrStepCompleted }]" ref="pageScrollContainer">
        <div v-if="isCompletedPr" class="completed-pr-header">
            <div class="completed-pr-header-row">
                <div class="completed-pr-header-left">
                    <p class="pr-type-name" :class="typeName">{{ localPrDetails?.prTypeName }}</p>
                    <div class="doc-name-editor-wrapper">
                        <span class="pr-title">{{ localPrDetails?.prName }}</span>
                        <RenamePopup v-if="isTitleEditing" :docName="localPrDetails?.prName" :isEditing="isTitleEditing"
                            @update-isEdit="isTitleEditing = $event" @updated-prTitle="localPrDetails.prName = $event"
                            flowType="pressRelease" />
                        <button class="edit-btn" @click="editTitle">
                            <img :src="require('@/assets/icons/edit.svg')" />
                        </button>

                    </div>

                </div>
            </div>

        </div>
        <div class="final-pr-header" v-else-if="isfinalPrStepCompleted">
            <div class="pr-final-header-left">
                <img :src="require('@/assets/icons/pr-completed.svg')" />
                <div class="completed-msg">
                    <h2 class="title">Press Release Generated</h2>
                </div>
            </div>
            <div class="pr-final-header-right">
                <div class="pr-final-btn-wrapper">
                    <img :src="require('@/assets/icons/share.svg')"></img>
                    <p class="home-btn-text">Share</p>
                </div>

                <button class="pr-final-btn-wrapper" @click="goToHome()">
                    <img :src="require('@/assets/icons/home.svg')" alt="">
                    <p class="home-btn-text">Go to Dashboard</p>
                </button>

                <button class="pr-final-btn-wrapper" :disabled="downloadPrLoader" @click="downloadFinalPr()">
                    <v-progress-circular v-if="downloadPrLoader" indeterminate :size="18"
                        :width="2"></v-progress-circular>
                    <div v-else class="download-wrapper">
                        <Svg :src="require('@/assets/icons/download.svg')" fill="white"></Svg>
                        <p>Download</p>
                    </div>
                </button>
            </div>
        </div>

        <div class="header" v-else>
            <div class="header-left">
                <span class="top-text">Press Release Finalized</span>
                <span class="bottom-text">[Complete final edits and ready for release]</span>
            </div>

            <div v-if="!isEditing" class="header-right">
                <button class="edit-btn" @click="editPr()">
                    <Svg :src="EditIcon" fill="black"></Svg>
                </button>
                <button class="edit-btn" @click="downloadFinalPr()" :disabled="downloadPrLoader">
                    <img :src="require('@/assets/icons/download.svg')" />
                </button>
            </div>
            <div v-else class="header-right">
                <button class="save-changes-btn" @click="savePr" :disabled="previousVersion === editedVersion">
                    <Svg :src="require('@/assets/icons/save.svg')" fill="#262626"></Svg>
                    Save Changes
                </button>
                <button class="edit-btn" @click="cancelPrChanges">
                    <img :src="require('@/assets/icons/close.svg')"></img>
                </button>
            </div>
        </div>
        <div class="sub-header" v-if="isfinalPrStepCompleted">
            <div class="version-toggle">
                <div class="original-version-toggle" :class="{ 'media-pitch-mode': toggleVersion === 'mediaPitch' }">
                    <button
                        :class="['toggle-btn', { active: toggleVersion === 'final' && selectedFinalVersion !== 'mediaPitch' }]"
                        @click="changeVersion('final')">
                        <!-- LEFT ARROW -->
                        <div v-if="availableFinalVersions.indexOf(selectedFinalVersion) > 0" class="arrow-btn"
                            @click.stop="goPrevVersion">
                            <img :src="require('@/assets/icons/left-arrow.svg')" />
                        </div>

                        {{ currentFinalLabel }}

                        <div v-if="
                            availableFinalVersions.indexOf(selectedFinalVersion) <
                            availableFinalVersions.length - 1
                        " class="arrow-btn" @click.stop="goNextVersion">
                            <img :src="require('@/assets/icons/right-arrow.svg')" />
                        </div>
                    </button>
                </div>



                <button v-if="mediaPitchContent || localPrDetails.mediaPitch"
                    :class="['toggle-btn', { active: toggleVersion === 'mediaPitch' }]"
                    @click="changeVersion('mediaPitch')">
                    Media Pitch
                </button>

            </div>
            <div v-if="!mediaPitchContent && !localPrDetails.mediaPitch" class="dropdown-wrapper">
                <button class="shorten" @click="toggleDropdown">
                    <p>Options</p>
                    <img :src="require('@/assets/icons/dropdown.svg')" />
                </button>
                <div class="dropdown-menu" v-if="isOpen">
                    <p class="dropdown-title">Generate options</p>

                    <div class="dropdown-item" @click="handleMediaPitch">
                        <img :src="require('@/assets/icons/pitch-icon.svg')" />
                        <span>Generate Media Pitch</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="final-pr-container">
            <div class="final-pr-wrapper">
                <div class="pr-details invisible-scroll" @mouseup="checkSelection" @mousedown.self="closeContextMenu"
                    ref="prDetails">
                    <div v-if="toggleVersion !== 'mediaPitch'" class="details-title"> {{ localPrDetails?.prTitle }}
                    </div>

                    <div class="pr-details-wrapper" v-html="renderedContent" ref="detailsContainer" :key="refresh"
                        id="edit-container" v-if="!isEditing">
                    </div>

                    <div v-show="isEditing" class="editor-wrapper">
                        <div ref="editorContainer">
                            <div ref="editor" class="quill-editor"></div>
                        </div>
                    </div>
                    <DragActionPopup v-if="isCompletedPr || isfinalPrStepCompleted" ref="contextMenu"
                        :show-menu="showContextMenu" :menuPosition="menuPosition" :documentData="popupData"
                        @close="closeContextMenu" @comment-added="handleCommentAdded" :version="selectedFinalVersion"
                        :commentedLength=localPrDetails?.commentsVersion.length :isCommentDisabled="isCommentDisabled"
                        :isArticleAllowed="isArticleAllowed" :isVersionLocked="isVersionLocked"
                        :shouldShowOverlapInfo="shouldShowOverlapInfo" />
                </div>
            </div>

            <div v-if="isfinalPrStepCompleted" class="right-panel ">

                <div class="right-panel-tabs">
                    <div class="tab-item" :class="{ active: rightPanelTab === 'generate' }"
                        @click="rightPanelTab = 'generate'">
                        <img :src="require('@/assets/icons/plusIcon.svg')" class="preview-img" />
                        Generate More
                    </div>

                    <div class="tab-item" :class="{ active: rightPanelTab === 'comments' }"
                        @click="rightPanelTab = 'comments'">
                        Comments
                    </div>
                </div>
                <div v-if="rightPanelTab === 'comments' && comments.length != 0" class="empty-comments-banner">
                    <img :src="require('@/assets/icons/info-black.svg')" />
                    <span>Comments are supported only on the <span style="font-weight: 600;">"Finalised version"</span>
                        and the subsequent versions</span>
                </div>


                <div v-if="rightPanelTab === 'generate'" class="panel-content invisible-scroll">
                    <div class="meta-data-wrapper">
                        <p class="header-title">Source-code Campaigning - generate assets, content and campaigns at
                            scale
                        </p>
                        <div class="assets-container">
                            <div class="assets-wrapper" @click="openGeneratePopup('Social Media Campaign')">
                                <div class="asset-left">
                                    <img :src="require('@/assets/icons/social-media-icon.svg')" />
                                    <p class="asset-type">Generate Social Media Campaign</p>
                                </div>
                                <img :src="require('@/assets/icons/create-icon.svg')" />
                            </div>

                            <div class="assets-wrapper" @click="openGeneratePopup('PR Strategy Play Book')">
                                <div class="asset-left">
                                    <img :src="require('@/assets/icons/pr-campaign-icon.svg')" />
                                    <p class="asset-type">Generate PR Strategy</p>
                                </div>
                                <img :src="require('@/assets/icons/create-icon.svg')" />
                            </div>

                            <div class="assets-wrapper" @click="createArticle()">
                                <div class="asset-left">
                                    <img :src="require('@/assets/icons/article-icon.svg')" />
                                    <p class="asset-type">Generate Articles</p>
                                </div>
                                <img :src="require('@/assets/icons/create-icon.svg')" />
                            </div>

                            <div class="assets-wrapper" @click="openGeneratePopup('Storybank')">
                                <div class="asset-left">
                                    <img :src="require('@/assets/icons/storyBoardIcon.svg')" />
                                    <p class="asset-type">Generate Storybank</p>
                                </div>
                                <img :src="require('@/assets/icons/create-icon.svg')" />
                            </div>
                        </div>
                    </div>
                    <div v-if="isCompletedPr">
                        <div class="details-wrapper">
                            <div class="meta-data-header">
                                <p class="header-title">Details</p>
                            </div>
                            <div class="details-container">
                                <div class="meta-wrapper">
                                    <p class="meta-data">Created On</p>
                                    <p class="meta-value">{{ formateDate(localPrDetails?.createdAt) }}</p>
                                </div>
                                <div class="meta-wrapper">
                                    <p class="meta-data">Completed On</p>
                                    <p class="meta-value">{{ formateDate(localPrDetails?.completedAt) }}</p>
                                </div>
                                <div class="meta-wrapper">
                                    <p class="meta-data">Created By</p>
                                    <p class="meta-value">{{ localPrDetails?.createdByName }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="rightPanelTab === 'comments'" class="panel-content comments-panel">
                    <!-- EMPTY STATE -->
                    <div v-if="!comments.length && selectedFinalVersion === 'v3'" class="empty-comments">
                        <img :src="require('@/assets/icons/comment-grayscale.webp')" class="empty-comments-img" />
                        <h3 class="empty-title">Version limit reached.</h3>
                        <p class="empty-desc">
                            You’ve hit the maximum number of comment-based changes allowed for this finalised version.

                        </p>
                    </div>
                    <div v-else-if="!comments.length" class="empty-comments">
                        <img :src="require('@/assets/icons/comment-01.svg')" class="empty-comments-img" />

                        <h3 class="empty-title">Introducing Comments</h3>

                        <p class="empty-desc">
                            Highlight the lines that need adjustments and give context for the AI to comprehend. Users
                            can add several comments simultaneously to implement all changes at once.
                        </p>

                        <img class="tour-image" :src="require('@/assets/images/comments-intro.png')" />

                        <!-- INTRO INFO LINE -->
                        <div class="empty-comments-info">
                            <img :src="require('@/assets/icons/info-icon.svg')" />
                            <span>Comments are supported on the original version as well as all subsequent
                                versions</span>
                        </div>
                    </div>

                    <div v-else>

                        <div class="comments-list" ref="commentsList">

                            <div class="comment-card" v-for="(comment, index) in comments"
                                :key="comment.commentId || index"
                                :class="{ active: activeCommentId === comment.commentId }"
                                :data-comment-id="comment.commentId" @click="onCommentClick(comment)">

                                <div class="comment-header">
                                    <div class="comment-top-row">
                                        <span class="comment-time">{{ formateCommentDate(comment.createdAt)
                                        }}</span>

                                        <div class="comment-actions">
                                            <template v-if="editingCommentId === comment.commentId">
                                                <button class="icon-btn" @click.stop="saveEditedComment(comment)"
                                                    :disabled="isSaveCommentDisabled || editingReplyText === ''">
                                                    <Svg :src="require('@/assets/icons/save.svg')" fill="#fff"></Svg>
                                                </button>

                                                <button class="icon-btn" @click.stop="cancelEditComment">
                                                    <img :src="require('@/assets/icons/cancel.svg')" class="cancel-img">
                                                </button>
                                            </template>

                                            <!-- VIEW MODE -->
                                            <template v-else>
                                                <button v-if="!disableActionsForCurrentVersion" class="icon-btn"
                                                    @click.stop="startEditComment(comment)">
                                                    <img :src="require('@/assets/icons/edit.svg')" />
                                                </button>

                                                <button v-if="!disableActionsForCurrentVersion" class="icon-btn"
                                                    @click.stop="handleDeleteComment(comment.commentId)"
                                                    :disabled="deletingCommentId === comment.commentId">
                                                    <v-progress-circular v-if="deletingCommentId === comment.commentId"
                                                        indeterminate :size="14" :width="2" color="white" />
                                                    <img v-else :src="require('@/assets/icons/delete.svg')" />
                                                </button>
                                            </template>

                                        </div>
                                    </div>
                                    <p class="comment-highlight">
                                        {{ comment.selectedText }}
                                    </p>
                                </div>

                                <div class="comment-reply">
                                    <img class="reply-arrow" :src="require('@/assets/icons/reply-arrow.svg')" />
                                    <textarea v-if="editingCommentId === comment.commentId" v-model="editingReplyText"
                                        class="reply-textarea" rows="5" />

                                    <span v-else class="reply-text">
                                        {{ comment.comments }}
                                    </span>
                                </div>

                            </div>


                        </div>

                    </div>

                </div>
                <div v-if="rightPanelTab === 'comments' && comments.length > 0 && !disableActionsForCurrentVersion"
                    class="comment-actions-bar">
                    <button class="secondary-btn" :disabled="isCommentEditing" @click="handleRemoveAllComment()">Remove
                        All
                        <v-progress-circular v-if="removeAllLoader" indeterminate :size="14" :width="2" color="white" />
                    </button>
                    <button class="primary-btn" @click="generatePRFromComments()" :disabled=" isCommentEditing">Generate
                        <img class="primary-btn-image" :src="require('@/assets/icons/next.svg')" alt="" />
                    </button>
                </div>



            </div>

        </div>
    </div>
    <GeneratePopup v-if="generatePopup" v-model="generatePopup" :flowType="selectedFlowType" :documentData=documentData>
    </GeneratePopup>
    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handlePopupConfirmation" />
    <v-overlay :model-value="pageLoader" class="overlay" persistent="true">
        <RotatingLoader :size="30" :speed="0.6" />
        <span>Generating</span>
    </v-overlay>
</template>

<script>
import EditIcon from '@/assets/icons/edit.svg';
import { downloadPr } from '@/helper/downloadPr';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { saveDraft } from '@/helper/saveAsDraft';
import moment from 'moment-timezone';
import RenamePopup from '@/components/RenamePopup.vue';
import CommonPopup from '@/components/CommonPopup.vue';
import GeneratePopup from '@/components/GeneratePopup.vue';
import DragActionPopup from '@/components/DragPopup.vue';
import axiosInstance from '@/axiosInterceptor';
import { Eventbus } from '@/plugins/eventBus';
import RotatingLoader from '@/components/CircularProgressBar.vue';

const FINAL_VERSION_MAP = {
    final: 'final',
    v2: 'version2',
    v3: 'version3'
}

export default {

    components: {
        RenamePopup,
        CommonPopup,
        GeneratePopup,
        DragActionPopup,
        RotatingLoader
    },


    props: {
        visitedModulesProp: {
            type: Object,
            default: () => { }
        },
        isfinalPrStepCompleted: {
            type: Boolean
        },
        isCompletedPr: {
            type: Boolean
        },
        modelValue: {
            type: Object
        },
        commentsData: {
            type: Object
        },
        prId: {
            type: String
        },
        prTypeId: {
            type: String
        },

    },
    data() {
        return {
            EditIcon,
            isOpen: false,
            pageLoader: false,
            activeVersion: 0,
            toggleVersion: "final",
            editableText: null,
            editor: null,
            isEditing: false,
            generatePopup: false,
            originalPr: null,
            refresh: 0,
            shareUrl: null,
            documentData: null,
            isFormValid: false,
            originalTitle: this.modelValue?.prName,
            selectedFlowType: '',
            newTitle: null,
            isTitleEditing: false,
            saveDocTitleLoader: false,
            showCommonPopup: false,
            popupType: null,
            previousVersion: null,
            editedVersion: null,
            downloadPrLoader: false,
            typeName: null,
            showContextMenu: false,
            menuPosition: { left: 0, top: 0 },
            selectedText: '',
            popupData: null,
            mediaPitchContent: null,
            rightPanelTab: 'generate',
            commmentToDelete: null,
            currentOriginalVersion: 1,
            maxVersion: 3,
            activeCommentId: null,
            editingCommentId: null,
            editingReplyText: '',
            originalReplyText: '',
            selectedFinalVersion: 'final',
            prDetailsLocal: {
                commentsVersion: []
            },
            deletingCommentId: null,
            removeAllLoader: false,
            localCommentsData: [],
            generatedMaxVersion: 0

        }
    },
    computed: {
        localPrDetails: {

            get() {
                if (!this.modelValue) {
                    return { typeName: '' }
                }

                const { prTypeName, ...rest } = this.modelValue
                this.typeName = (prTypeName ?? '')
                    .split(' ')
                    .join('-')
                    .toLowerCase()

                return {
                    ...rest,
                    prTypeName
                }
            }
        },
        isCommentEditing() {
            return !!this.editingCommentId
        },
        finalVersions() {
            const versions = {
                final: {
                    label: 'Finalized Version',
                    content: this.cleanedPrContent
                }
            }

            const source =
                this.prDetailsLocal?.commentsVersion?.length
                    ? this.prDetailsLocal.commentsVersion
                    : this.localPrDetails?.commentsVersion || []

            source.forEach(v => {
                versions[`v${v.version}`] = {
                    label: `Version ${v.version}`,
                    content: v.commentedContent
                }
            })

            return versions
        },

        availableFinalVersions() {
            return Object.entries(this.finalVersions)
                .filter(([_, v]) => v && v.content)
                .map(([key]) => key)
        },
        comments() {
            if (this.toggleVersion === 'mediaPitch') return []
            const apiVersionType = FINAL_VERSION_MAP[this.selectedFinalVersion]

            if (!apiVersionType) return []


            const groups = this.localPrDetails?.commentsData || []

            const versionGroup = groups.find(
                g => g.versionType === apiVersionType
            )

            if (!versionGroup || !Array.isArray(versionGroup.comments)) {
                return []
            }

            return versionGroup.comments.filter(
                c => c.status === 'ACTIVE'
            )
        },

        isHtmlContent() {
            return typeof this.localPrDetails?.prContent === 'string';
        },
        cleanedPrContent() {
            if (!this.isHtmlContent) return '';

            let htmlContent = this.localPrDetails?.prContent;
            return htmlContent;
        },
        renderedContent() {
            if (this.toggleVersion === 'mediaPitch') {
                return this.mediaPitchContent || this.localPrDetails?.mediaPitch
            }

            return this.finalVersions[this.selectedFinalVersion]?.content || ''
        },
        currentFinalLabel() {
            return this.finalVersions[this.selectedFinalVersion]?.label || ''
        },
        isSaveCommentDisabled() {
            if (!this.editingCommentId) return true

            return (
                this.editingReplyText.trim() ===
                this.originalReplyText.trim()
            )
        },
        allCommentVersions() {
            return (
                this.prDetailsLocal.commentsVersion?.length
                    ? this.prDetailsLocal.commentsVersion
                    : this.localPrDetails.commentsVersion || []
            )
        },

        maxGeneratedVersion() {
            return this.allCommentVersions.length
                ? Math.max(...this.allCommentVersions.map(v => v.version))
                : 0
        },


        disableActionsForCurrentVersion() {
            if (this.selectedFinalVersion === 'final' && this.generatedMaxVersion >= 2)
                return true

            if (this.selectedFinalVersion === 'v2' && this.generatedMaxVersion >= 3)
                return true

            return false
        },
        isCommentDisabled() {
            if (this.popupData?.hasOverlap) return true
            if (this.selectedFinalVersion === 'final' && this.generatedMaxVersion >= 2)
                return true

            if (this.selectedFinalVersion === 'v2' && this.generatedMaxVersion >= 3)
                return true
            return false
        }
        ,
        isArticleAllowed() {
            return this.selectedFinalVersion === 'final'
        },
        isVersionLocked() {
            const versions = this.allCommentVersions || []
            const count = versions.length

            if (this.selectedFinalVersion === 'final' && count >= 1) {
                return true
            }

            if (this.selectedFinalVersion === 'v2' && count >= 3) {
                return true
            }

            return false
        },

        shouldShowOverlapInfo() {
            return (
                !!this.popupData?.hasOverlap &&
                !this.isVersionLocked
            )
        }


    },
    watch: {
        toggleVersion() {
            this.$nextTick(() => this.applyComments())
        },
        comments() {
            this.$nextTick(() => this.applyComments())
        },

    },

    methods: {
        async removeAllComments() {
            try {
                this.removeAllLoader = true

                await axiosInstance.post('/comments/delete/all', {
                    documentId: this.$route.params.prId,
                    versionType: this.getApiVersionType(),
                    documentType: 'PR'
                })

                this.updateCommentsLocally({ action: 'clear' })

                Eventbus.emit('commonSnackbar', {
                    snackType: 'success',
                    message: 'Comments removed successfully'
                })
            } catch (e) {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Unable to remove comments'
                })
            } finally {
                this.removeAllLoader = false
            }
        },
        handleCommentAdded(newComment) {
            if (this.isfinalPrStepCompleted && !this.isCompletedPr) {
                this.$emit('update:modelValue', {
                    ...this.localPrDetails
                })
                return
            }
            else {
                const versionType = this.getApiVersionType();

                let group = this.localPrDetails.commentsData?.find(
                    g => g.versionType === versionType
                );

                if (!group) {
                    group = {
                        versionType: versionType,
                        comments: []
                    };

                    if (!this.localPrDetails.commentsData) {
                        this.localPrDetails.commentsData = [];
                    }
                    this.localPrDetails.commentsData.push(group);
                }

                const commentToAdd = {
                    ...newComment,
                    versionType: versionType,
                    startOffset: this.popupData?.startOffset || 0,
                    endOffset: this.popupData?.endOffset || 0,
                    status: 'ACTIVE'
                };
                group.comments.push(commentToAdd);
                this.$nextTick(() => {
                    this.applyComments();
                    this.showContextMenu = false;
                    this.rightPanelTab = 'comments';
                });
            }
        },
        handleDeleteComment(id) {
            this.popupType = 'deleteComment'
            this.showCommonPopup = true;
            this.commmentToDelete = id;
        },
        handleRemoveAllComment() {
            this.popupType = 'deleteAll'
            this.showCommonPopup = true;
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        goPrevVersion() {
            const list = this.availableFinalVersions
            const idx = list.indexOf(this.selectedFinalVersion)
            if (idx > 0) {
                this.selectedFinalVersion = list[idx - 1]
            }
            this.toggleVersion = 'final'
            this.$emit("update:toggleVersion", 'final')
            this.$emit("update:currentOriginalVersion", this.selectedFinalVersion);
        },

        goNextVersion() {
            const list = this.availableFinalVersions
            const idx = list.indexOf(this.selectedFinalVersion)
            if (idx < list.length - 1) {
                this.selectedFinalVersion = list[idx + 1]
            }
            this.toggleVersion = 'final'
            this.$emit("update:toggleVersion", 'final')
            this.$emit("update:currentOriginalVersion", this.selectedFinalVersion);
        },
        changeVersion(version) {
            this.toggleVersion = version;
            this.$emit("update:toggleVersion", version);
        },

        async handleMediaPitch() {
            this.isOpen = false;
            await this.generateMediaPitch()

        },
        async generateMediaPitch() {
            try {
                this.pageLoader = true;
                const response = await axiosInstance.post('/mediaPitch/generate', {
                    inputId: this.$route.params.prId,
                    moduleType: 'PR'
                });
                if (response.status == 200) {
                    this.mediaPitchContent = response.data.data.mediaPitch.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '').replace(/\n/g, '').trim();
                    this.toggleVersion = 'mediaPitch';
                    this.$emit("update:toggleVersion", this.toggleVersion);
                    this.showOriginal = false;
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'save',
                        message: 'Media Pitch version generated successfully',
                    });
                }

            } catch (error) {
                if (error.response?.status === 502 || error.code === 'ERR_NETWORK' || error.response?.status === 504) {
                    let attempts = 0;
                    let maxAttempts = 40;
                    const intervalTime = 15000;
                    const intervalId = setInterval(async () => {
                        attempts++;
                        try {
                            this.$emit('update:modelValue', { ...this.localPrDetails });
                            if (this.shortenedContent && this.shortenedContent.trim() !== "") {
                                clearInterval(intervalId);
                                this.toggleVersion = 'mediaPitch';
                                this.showOriginal = false;
                                Eventbus.emit('commonSnackbar', {
                                    snackType: 'save',
                                    message: 'Media Pitch version generated successfully',
                                });

                            } else if (attempts >= maxAttempts) {
                                clearInterval(intervalId);
                                this.pageLoader = false;
                            }

                        } catch (pollError) {
                            console.error("Error during polling:", pollError);
                            clearInterval(intervalId);
                            this.pageLoader = false;
                            Eventbus.emit('commonSnackbar', {
                                snackType: 'error',
                                message: 'Failed to generate PR. Please try again later.'
                            });
                        }
                    }, intervalTime);
                }
            } finally {
                this.pageLoader = false;


            }
        },
        checkSelection() {
            if (this.toggleVersion === 'mediaPitch') return

            if (
                (this.selectedFinalVersion === 'v2' && this.generatedMaxVersion >= 3) ||
                this.selectedFinalVersion === 'v3'
            ) {
                this.showContextMenu = false
                return
            }

            const selection = window.getSelection()
            if (!selection || selection.rangeCount === 0) {
                this.showContextMenu = false
                return
            }

            const range = selection.getRangeAt(0)

            if (range.collapsed) {
                this.showContextMenu = false
                return
            }

            const container = this.$refs.detailsContainer
            const scrollContainer = this.$refs.prDetails

            if (!container || !scrollContainer) {
                this.showContextMenu = false
                return
            }

            if (
                !container.contains(range.startContainer) ||
                !container.contains(range.endContainer)
            ) {
                this.showContextMenu = false
                return
            }

            const selectedText = selection.toString().replace(/\s+/g, ' ').trim()
            if (!selectedText) {
                this.showContextMenu = false
                return
            }

            const overlappingHighlight = this.getOverlappingHighlight(range)

            const { startOffset, endOffset } = this.getOffsets(range)

            const rects = range.getClientRects()
            if (!rects.length) {
                this.showContextMenu = false
                return
            }

            const lastRect = rects[rects.length - 1]
            const containerRect = scrollContainer.getBoundingClientRect()

            let top =
                lastRect.bottom -
                containerRect.top +
                scrollContainer.scrollTop +
                8

            let left =
                lastRect.left -
                containerRect.left +
                scrollContainer.scrollLeft

            this.popupData = {
                documentId: this.$route.params.prId,
                documentType: 'PR',
                sectionContent: selectedText,
                startOffset,
                endOffset,
                versionType: this.getApiVersionType(),
                hasOverlap: !!overlappingHighlight
            }

            this.showContextMenu = true

            this.$nextTick(() => {
                const popupEl = this.$refs.contextMenu?.$el
                if (!popupEl) return

                const popupHeight = popupEl.offsetHeight
                const popupWidth = popupEl.offsetWidth

                const maxTop =
                    scrollContainer.scrollHeight - popupHeight - 8
                const maxLeft =
                    scrollContainer.clientWidth - popupWidth - 8

                if (top + popupHeight > scrollContainer.scrollHeight) {
                    const firstRect = rects[0]
                    top =
                        firstRect.top -
                        containerRect.top +
                        scrollContainer.scrollTop -
                        popupHeight -
                        8
                }

                this.menuPosition = {
                    top: Math.max(8, Math.min(top, maxTop)),
                    left: Math.max(8, Math.min(left, maxLeft))
                }
            })
        },


        getOverlappingHighlight(range) {
            const container = this.$refs.detailsContainer
            if (!container) return null

            const highlights = container.querySelectorAll('.highlight-comment')

            return Array.from(highlights).find(el => {
                try {
                    return range.intersectsNode(el)
                } catch {
                    return false
                }
            })
        },



        getOffsets(range) {
            const container = this.$refs.detailsContainer
            if (!container) return { startOffset: 0, endOffset: 0 }

            let offset = 0
            const walker = document.createTreeWalker(
                container,
                NodeFilter.SHOW_TEXT,
                null
            )

            while (walker.nextNode()) {
                const node = walker.currentNode

                if (node === range.startContainer) {
                    offset += range.startOffset
                    break
                } else {
                    offset += node.textContent.length
                }
            }

            const length = range.toString().length

            return {
                startOffset: offset,
                endOffset: offset + length
            }
        },


        wrapRange(container, start, end, commentId) {
            const walker = document.createTreeWalker(
                container,
                NodeFilter.SHOW_TEXT,
                null
            )

            let currentOffset = 0
            const tasks = []
            while (walker.nextNode()) {
                const node = walker.currentNode
                const text = node.textContent || ''
                const length = text.length

                const nodeStart = currentOffset
                const nodeEnd = nodeStart + length
                if (!/\S/.test(text)) {
                    currentOffset += length
                    continue
                }

                if (end > nodeStart && start < nodeEnd) {
                    tasks.push({
                        node,
                        from: Math.max(0, start - nodeStart),
                        to: Math.min(length, end - nodeStart)
                    })
                }

                currentOffset += length
                if (currentOffset >= end) break
            }
            tasks.forEach(({ node, from, to }) => {
                if (from >= to) return

                const text = node.textContent
                const selected = text.slice(from, to)

                if (!selected || !/\S/.test(selected)) return

                const before = text.slice(0, from)
                const after = text.slice(to)

                const parent = node.parentNode
                if (!parent) return

                const frag = document.createDocumentFragment()

                if (before) {
                    frag.appendChild(document.createTextNode(before))
                }

                const span = document.createElement('span')
                span.className = 'highlight-comment'
                span.dataset.id = commentId
                span.textContent = selected

                span.addEventListener('click', e => {
                    e.stopPropagation()
                    this.onHighlightClick(commentId)
                })

                frag.appendChild(span)

                if (after) {
                    frag.appendChild(document.createTextNode(after))
                }

                parent.replaceChild(frag, node)
            })
        },

        setActiveComment(id, source = 'comment') {
            this.activeCommentId = id

            const container = this.$refs.detailsContainer
            if (!container) return

            container
                .querySelectorAll('.highlight-comment.active')
                .forEach(el => el.classList.remove('active'))

            container
                .querySelectorAll(`span[data-id="${id}"]`)
                .forEach(el => el.classList.add('active'))

            if (source === 'highlight') {
                this.rightPanelTab = 'comments'

                this.$nextTick(() => {
                    this.scrollToComment(id)
                })
            }
        },

        onCommentClick(comment) {
            this.setActiveComment(comment.commentId, 'comment')
            this.scrollToHighlight(comment.commentId)
        },

        scrollToHighlight(id) {
            this.$nextTick(() => {
                const highlight =
                    this.$refs.detailsContainer?.querySelector(
                        `span[data-id="${id}"]`
                    )

                if (!highlight) return

                const scrollContainer = this.$refs.prDetails
                if (!scrollContainer) return

                const containerRect = scrollContainer.getBoundingClientRect()
                const highlightRect = highlight.getBoundingClientRect()

                const top =
                    highlightRect.top -
                    containerRect.top +
                    scrollContainer.scrollTop -
                    120

                scrollContainer.scrollTo({
                    top,
                    behavior: 'smooth'
                })

                highlight.classList.add('active-comment-highlight')
                setTimeout(() => {
                    highlight.classList.remove('active-comment-highlight')
                }, 1200)
            })
        },

        onHighlightClick(id) {
            this.setActiveComment(id, 'highlight')

            this.$nextTick(() => {
                this.scrollToHighlight(id, 'highlight')
                this.scrollToComment(id)
            })
        },

        scrollToComment(id) {
            this.$nextTick(() => {
                const list = this.$refs.commentsList
                if (!list) return

                const el = list.querySelector(
                    `.comment-card[data-comment-id="${id}"]`
                )

                if (!el) return

                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                })
            })
        },


        applyComments() {
            const container = this.$refs.detailsContainer
            if (!container) return

            container.innerHTML = this.renderedContent

            this.$nextTick(() => {
                const sorted = [...this.comments].sort(
                    (a, b) => b.startOffset - a.startOffset
                )

                sorted.forEach(c => {
                    this.wrapRange(container, c.startOffset, c.endOffset, c.commentId)
                })

                if (this.activeCommentId) {
                    this.setActiveComment(this.activeCommentId)
                }
            })
        },

        closeContextMenu() {
            this.showContextMenu = false;
        },
        async saveArticleDraft(articleId) {
            let endpoint = '/article/saveDraft'
            let payload = {
                articleId: articleId,
            }
            let documentData = {};
            documentData = {
                documentId: this.$route.params.prId,
                documentType: 'PR',
                section: this.selectedText,
            }

            payload.lastUpdatedStage = 'SOURCE_DOC';
            payload.documentData = documentData

            await axiosInstance.put(endpoint, payload)
                .then((response) => {
                    this.showArticleStage = true;
                    this.$router.push({ name: 'ArticleStages', params: { articleId: articleId }, state: { locked: true } });
                })
                .catch((error) => {
                    console.error('[ERROR] ', error);
                    Eventbus.emit('commonSnackbar', {
                        snackType: 'error',
                        message: 'Failed to save changes',
                    });
                })
        },
        updateCommentsLocally({ action, commentId, newText }) {
            const versionType = this.getApiVersionType()

            const group = this.localPrDetails.commentsData?.find(
                g => g.versionType === versionType
            )

            if (!group || !Array.isArray(group.comments)) return

            switch (action) {
                case 'edit': {
                    const comment = group.comments.find(
                        c => c.commentId === commentId
                    )
                    if (comment) {
                        comment.comments = newText
                    }
                    break
                }

                case 'delete': {
                    group.comments = group.comments.filter(
                        c => c.commentId !== commentId
                    )

                    if (this.activeCommentId === commentId) {
                        this.activeCommentId = null
                    }
                    break
                }

                case 'clear': {
                    group.comments = []
                    this.activeCommentId = null
                    break
                }
            }
        },


        async createArticle() {
            this.pageLoader = true;
            let endpoint = '/article/create';
            let payload = {
                articleDocumentName: null
            }
            await axiosInstance.post(endpoint, payload)
                .then(async (response) => {
                    this.articleId = response.data.data.articleId;
                    if (response.status === 201) {
                        await this.saveArticleDraft(this.articleId)
                    }
                })
                .catch((error) => {
                    Eventbus.emit({
                        snackType: 'error',
                        message: 'Failed to create new article'
                    })
                })
                .finally(() => {
                    this.pageLoader = false;

                })
        },
        openGeneratePopup(type) {
            this.selectedFlowType = type
            this.generatePopup = true
        },
        async handlePopupConfirmation(val) {
            this.showCommonPopup = false
            if (val !== 'yes') return

            try {
                switch (this.popupType) {

                    case 'deleteComment': {
                        this.deletingCommentId = this.commmentToDelete

                        await axiosInstance.post('/comments/delete', {
                            documentId: this.$route.params.prId,
                            versionType: this.getApiVersionType(),
                            commentId: this.commmentToDelete,
                            status: 'DELETED',
                            documentType: 'PR'
                        })

                        this.updateCommentsLocally({
                            action: 'delete',
                            commentId: this.commmentToDelete
                        })

                        Eventbus.emit('commonSnackbar', {
                            snackType: 'save',
                            message: 'Comment deleted successfully'
                        })
                        break
                    }


                    case 'deleteAll': {
                        await this.removeAllComments()
                        break
                    }

                    case 'withoutSave': {
                        this.isEditing = false
                        this.$emit('update:isEditingFinalPr', this.isEditing)
                        break
                    }
                }

            } catch (error) {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Action failed'
                })
            } finally {
                this.deletingCommentId = null
                this.commmentToDelete = null
                this.popupType = null
            }
        },


        formateDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        formateCommentDate(date) {
            return moment(date).format('Do MMM, YYYY HH:mm');
        },

        goToHome() {
            this.$router.push({ name: 'PressRelease' });
        },

        editPr() {
            this.isEditing = !this.isEditing;
            this.$emit('update:isEditingFinalPr', this.isEditing);
            this.previousVersion = this.localPrDetails?.prContent;
            this.editedVersion = this.localPrDetails?.prContent;
            this.editor.root.innerHTML = this.localPrDetails?.prContent;
        },
        cancelPrChanges() {
            if (this.previousVersion !== this.editedVersion) {
                this.isEditing = false;
                this.$emit('update:isEditingFinalPr', this.isEditing);
            } else {
                this.popupType = 'withoutSave';
                this.showCommonPopup = true;
            }
        },
        async savePr() {
            const updatedContent = this.editor.root.innerHTML;
            let payload = {
                versionNumber: this.modelValue.versionNumber,
                prContent: updatedContent,
                prTitle: this.localPrDetails.prTitle,
                prId: this.prId,
                typeId: this.prTypeId
            }
            await saveDraft(payload);
            this.localPrDetails.prContent = updatedContent;
            this.$emit('update:modelValue', { ...this.localPrDetails });
            this.isEditing = !this.isEditing;
            this.$emit('update:isEditingFinalPr', this.isEditing);
            this.refresh += 1;
        },

        async downloadFinalPr() {

            this.downloadPrLoader = true;
            const payload = {
                prId: this.$route.params.prId,
                version: String(this.localPrDetails.versionNumber), 
                flowType: "PR",
                versionType: this.toggleVersion
            }
            let prTitle;
            if (!this.isCompletedPr && !this.isfinalPrStepCompleted) {
                prTitle = this.localPrDetails.prTitle ?? this.localPrDetails?.prName
            } else {
                let filename;
                filename = this.localPrDetails.prTitle ?? this.localPrDetails?.prName;

                if (this.toggleVersion === 'mediaPitch') {
                    prTitle = `${filename}_mediapitch`;
                } else {
                    prTitle = `${filename}_final`;
                }
            }

            await downloadPr(payload, prTitle);
            this.downloadPrLoader = false;
        },
        editTitle() {
            this.isTitleEditing = true;
            this.newTitle = this.originalTitle;
        },
        async saveTitle() {
            this.saveDocTitleLoader = true;
            this.isTitleEditing = false;
            const payload = {
                prName: this.newTitle,
                prId: this.prId
            }
            await axiosInstance.put('/pr/title', payload)
                .then((response) => {
                    if (response.data.success) {
                        this.originalTitle = this.newTitle;
                        Eventbus.emit('commonSnackbar', {
                            snackType: "save",
                            message: 'Document title updated successfully'
                        });

                    } else {
                        console.error("Error while updating title: ", response.data.message);
                    }
                })
                .catch((error) => {
                    console.error('Error while updating title', error);
                })
                .finally(() => {
                    this.saveDocTitleLoader = false;
                })
        },
        startEditComment(comment) {
            this.editingCommentId = comment.commentId
            this.editingReplyText = comment.comments
            this.originalReplyText = comment.comments
        },

        cancelEditComment() {
            this.editingCommentId = null
            this.editingReplyText = ''
        },


        async generatePRFromComments() {
            this.pageLoader = true

            try {

                if (!this.prDetailsLocal.commentsVersion) {
                    this.prDetailsLocal.commentsVersion = []
                }
                const response = await axiosInstance.post('/comments/generate', {
                    documentId: this.$route.params.prId,
                    versionType: this.getApiVersionType(),
                    moduleType: 'PR'
                })

                const { version, commentedContent } = response.data.data
                const versionKey = `v${version}`

                this.prDetailsLocal.commentsVersion.push({
                    version,
                    commentedContent
                })
                this.generatedMaxVersion = version
                this.selectedFinalVersion = versionKey
                this.toggleVersion = 'final'
                this.rightPanelTab = 'comments'

                this.$emit("update:currentOriginalVersion", versionKey);

                this.$nextTick(this.applyComments)

                Eventbus.emit('commonSnackbar', {
                    snackType: 'save',
                    message: `Version ${version} generated successfully`
                })

            } catch (e) {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Failed to generate PR version'
                })
            } finally {
                this.pageLoader = false
            }
        },



        getApiVersionType() {
            return FINAL_VERSION_MAP[this.selectedFinalVersion]
        },
        async saveEditedComment(comment) {
            try {
                await axiosInstance.post('/comments/edit', {
                    documentId: this.$route.params.prId,
                    versionType: this.getApiVersionType(),
                    commentId: comment.commentId,
                    comments: this.editingReplyText,
                    documentType: 'PR'
                })

                this.updateCommentsLocally({
                    action: 'edit',
                    commentId: comment.commentId,
                    newText: this.editingReplyText
                })

                Eventbus.emit('commonSnackbar', {
                    snackType: 'save',
                    message: 'Comment updated successfully'
                })

                this.cancelEditComment()
            } catch (error) {
                Eventbus.emit('commonSnackbar', {
                    snackType: 'error',
                    message: 'Failed to update comment'
                })
            }
        },

        hasOverlappingComment(selectionStart, selectionEnd) {
            console.log(this.comments);
        }

    },

    mounted() {
        this.editor = new Quill(this.$refs.editor, {
            theme: 'snow',
        });
        this.editor.on('text-change', () => {
            this.editedVersion = this.editor.root.innerHTML;
        });

        this.documentData = {
            documentId: this.prId,
            documentName: this.localPrDetails?.prTitle,
            documentType: 'PR',
            imageUrl: require('@/assets/icons/pr-grey.svg')
        },
            this.$emit("update:currentOriginalVersion", this.selectedFinalVersion)
        if (this.localPrDetails?.commentsVersion?.length) {
            this.prDetailsLocal.commentsVersion = [
                ...this.localPrDetails.commentsVersion
            ]
        }

        this.generatedMaxVersion = this.prDetailsLocal.commentsVersion.length
            ? Math.max(...this.prDetailsLocal.commentsVersion.map(v => v.version))
            : 0

        this.$nextTick(() => this.applyComments())

    },
}
</script>

<style scoped>
.completed-pr-container {
    display: flex;
    height: 100%;
    flex-direction: column;
    width: 100%;
    padding: 2rem 9rem 2rem 13rem;
    justify-content: space-between;
    gap: 1rem;
    will-change: transform;
    overflow-y: auto;
    scrollbar-width: thin;
}

.completed-pr-container.not-complete {
    justify-content: center;
    padding: 2rem 20rem 2rem;
}

.final-pr-container {
    display: flex;
    flex-direction: row;
    will-change: transform;
    gap: 2.5rem;
    min-height: 0;
    flex: 1;
}

.final-pr-wrapper {
    display: flex;
    flex: 2;
    flex-direction: column;
    gap: 1rem;
    font-family: 'Inter', sans-serif;

}

.final-pr-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5em;
    background: var(--primary-gradient-with-black);
    padding: 1rem 1.5rem;
    border-radius: 8px;
    color: var(--secondary-font-color);
    justify-content: space-between;
}

.pr-final-header-left {
    display: flex;
    gap: 1rem;
}

.pr-final-header-right {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.pr-final-btn-wrapper {
    display: flex;
    gap: 0.5em;
    justify-content: center;
    background: #FFFFFF1F;
    border: 1px solid #FFFFFF33;
    align-items: center;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    font-size: var(--normal-font-size);
}

.overlay {
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    z-index: 9999;
}

.download-wrapper {
    display: flex;
    flex-direction: row;
    gap: 0.5em;
    justify-content: center;
    align-items: center;
}

.completed-msg {
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: white;
}


.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-left {
    display: flex;
    flex-direction: column;
}

.top-text {
    font-size: var(--header-font-size);
    font-weight: 600;
    text-align: left;
    color: #FAFAFA;
}

.bottom-text {
    font-size: var(--normal-font-size);
    text-align: left;
    color: #FFFFFF99;
    font-style: italic;
}

.header-right {
    display: flex;
    gap: 1em;
}

.dropdown-wrapper {
    position: relative;
    display: inline-block;
}

.shorten {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    gap: 8px;
    border-radius: 24px;
    border: 1px solid #FFFFFF33;
    color: white;
    cursor: pointer;
    font-size: 16px;
    background: transparent;
}

.dropdown-menu {
    position: absolute;
    top: 48px;
    right: 0;
    width: 260px;
    background: var(--secondary-font-color);
    color: black;
    border-radius: 16px;
    padding: 12px 0;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 9999;
}

.dropdown-title {
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    color: #737373;
    border-bottom: 1px solid #EEEEEE;
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 1px solid #EEEEEE;
    cursor: pointer;
}

.dropdown-item img {
    width: 22px;
    height: 22px;
}

.dropdown-item:last-child {
    border-bottom: none;
}

.edit-btn {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 50%;
    border: 1px solid #A3A3A3;
    background: white;
}

.sub-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 62%
}

.version-toggle {
    display: flex;
    gap: 8px;
    border-radius: 5rem;
    padding: 4px;
}

.toggle-btn {
    padding: 8px 20px;
    border: none;
    background: #FFFFFF33;
    color: #E5E5E5;
    cursor: pointer;
    border-radius: 5rem;
    font-size: var(--normal-font-size);
    display: flex;
    align-items: center;
    gap: 8px
}

.original-version-toggle.media-pitch-mode .arrow-btn img {
    filter: brightness(0) invert(1);
}

.toggle-btn.active {
    background: white;
    color: var(--primary-font-color);
}

.toggle-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.save-changes-btn {
    width: 11rem;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    gap: 0.7rem;
    border-radius: 1.5rem;
    background: white;
    color: #262626;
    border: 1px solid #A3A3A3;
}

.pr-details {
    display: flex;
    flex-direction: column;
    gap: 2em;
    padding: 3em;
    align-items: left;
    background-color: white;
    border-radius: 24px;
    overflow-y: auto;
}

.invisible-scroll {
    scrollbar-width: none;
}

/* Chrome, Edge, Safari */
.invisible-scroll::-webkit-scrollbar {
    width: 0px;
    height: 0px;
}


.pr-details::-webkit-scrollbar-button {
    display: none;
}

.pr-details::-webkit-scrollbar {
    width: 6px;
}

.pr-details::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 8px;
}

.pr-details::-webkit-scrollbar-thumb {
    background-color: #ffffff66;
    border-radius: 8px;
}

.pr-details::-webkit-scrollbar-thumb:hover {
    background-color: #ffffff99;
}


.pr-details :deep(::selection) {
    background: #FF780029;
}

.details-title {
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    color: #171717;
}

.pr-details-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.pr-title {
    font-weight: 600;
    font-size: 24px;
}

.completed-pr-header-row {
    display: flex;
    align-items: flex-start;
    gap: 2rem;
    width: 100%;
}

.completed-pr-header {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 1.5rem;
}

.completed-pr-header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
    flex: 2;
}

.pr-type-name {
    display: flex;
    align-items: center;
    border-radius: 4px;
    padding: 1px 16px;
    width: fit-content;
    justify-content: center;
    align-items: center;
}

.pr-type-name.general {
    color: #33AC37;
    background: #ECFFEC;
    border: 1px solid #D1F5D3;
}

.pr-type-name.product-launch {
    color: #0095FF;
    background-color: #F0F9FF;
    border: 1px solid #E3F2FF;
}

.pr-type-name.event-announcement {
    color: #FF27DE;
    background-color: #FFF0FD;
    border: 1px solid #FFE3FD;
}

.pr-type-name.funding\/m\&a {
    color: #FF900A;
    background: #FFF9EC;
    border: 1px solid #FFF3D3;
}

.doc-name-editor-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    color: white;
}

.pr-title {
    font-weight: 500;
    text-align: center;
}

.edit-title-input {
    width: 200px;
    align-items: center;
}

.doc-name-editor-wrapper .edit-btn {
    display: flex;
    border-radius: 8px;
    border: 1px solid #FFFFFF33;
    align-items: center;
    cursor: pointer;
    background: none;
}

.created-wrapper {
    color: #FFFFFF80;
    font-size: 14px;
    font-weight: 400;
}

.white-text {
    color: white;
}

.bold-text {
    font-weight: 500;
}

.completed-pr-header-right {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-end;
    justify-content: flex-end;
}

.right-container {
    display: flex;
    flex-direction: column;
    flex: 1.1;
    gap: 2rem;
}

.meta-data-wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    color: var(--secondary-font-color);
    border-radius: 12px;
}

.details-wrapper {
    gap: 1rem;
    color: var(--secondary-font-color);
    border-radius: 12px;
    border: 1px solid #FFFFFF1A;
}

.preview-img {
    width: 16px;
    height: 14px;
}

.meta-data-header {
    padding: 1rem 1.5rem;
    border-bottom: 2px solid #FFFFFF12;
}

.sub-header-title {
    font-style: italic;
}

.sub-span {
    font-style: normal;
}

.assets-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.details-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
}

.assets-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #FFFFFF13;
    border-radius: 8px;
    padding: 0.5rem 1rem;
}

.asset-left {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.meta-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.meta-data {
    color: #FFFFFF99;
}

.right-panel {
    display: flex;
    flex-direction: column;
    flex: 1.1;
    /* gap: 1rem; */
    background-color: #ffffff12;
    border-radius: 8px;
    height: 100%;
    min-height: 0;

}

.right-panel-tabs {
    display: flex;
    background: #ffffff13;
    justify-content: center;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid #FFFFFF1A;
}

.tab-item {
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px 0;
    font-size: var(--normal-font-size);
    color: #FFFFFF80;
    cursor: pointer;
    position: relative;
    gap: 4px;
}

.tab-item.active {
    color: #FFFFFF;
}

.tab-item.active::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -1px;
    width: 100%;
    /* FULL HALF WIDTH */
    height: 2px;
    background-color: #FFFFFF;
}

.panel-content {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1rem 1rem;
    overflow-y: auto;
}

.empty-comments {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 1rem;
    color: #FFFFFFCC;
}

.empty-comments-img {
    width: 30px;
    height: 30px;
}

.empty-title {
    font-size: 24px;
    font-weight: 700;
    color: #FFFFFF;
    font-family: 'OverpassMono'
}

.empty-desc {
    font-size: 14x;
    color: #FFFFFF99;
}

.tour-image {
    width: 350px;
    height: 200px;
}

.empty-comments- {
    display: flex;
    align-items: center;
    text-align: left;
    gap: 8px;
    background: #FFFFFF14;
    border-radius: 8px;
    padding: 12px;
    font-size: 14px;
    color: #FFFFDDD3;
}

.empty-comments-info {
    display: flex;
    align-items: center;
    text-align: left;
    gap: 8px;
    background: #FFFFFF14;
    border-radius: 8px;
    padding: 12px;
    font-size: 14px;
    color: #FFFFDDD3;
}

.empty-comments-banner {
    display: flex;
    align-items: flex-start;
    text-align: left;
    gap: 8px;
    background: var(--secondary-font-color);
    padding: 8px;
    font-size: 14px;
    color: var(--primary-font-color);
}

.empty-comments-banner img {
    /* align-items: center; */
    padding-top: 2px;
}

.empty-comments-info img {
    width: 16px;
    height: 16px;
    align-items: center;
}

.comment-card {
    background: #FFFFFF14;
    border: 1px solid #FFFFFF1F;
    border-radius: 8px;
    /* padding: 14px; */
    display: flex;
    flex-direction: column;
    /* gap: 10px; */
}

.comment-header {
    display: flex;
    flex-direction: column;
    background: #FFFFFF13;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 0.5rem;
    gap: 0.25rem;

}

.comment-top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.comment-time {
    font-size: 12px;
    color: #FFFFFF80;
}

.comment-text {
    font-size: 14px;
    color: #FFFFFF;
    line-height: 1.4;
}

.comment-actions {
    display: flex;
    gap: 8px;
}

.icon-btn {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: #FFFFFF1A;
    border: 1px solid #FFFFFF33;
    cursor: pointer;
}

.comment-highlight {
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 1.4;
    padding-top: 0.25rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;

}

.icon-btn img {
    width: 14px;
    height: 14px;
}

.comment-actions img {
    width: 16px;
    height: 16px;
    cursor: pointer;
    opacity: 0.85;
}

.comment-actions img:hover {
    opacity: 1;
}


.generate-btn {
    flex: 1;
    background: white;
    color: #171717;
    border: none;
    border-radius: 8px;
    padding: 10px;
    font-weight: 500;
    cursor: pointer;
}

.remove-btn {
    flex: 1;
    background: transparent;
    color: #FFFFFFCC;
    border: 1px solid #FFFFFF33;
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
}



.comments-panel {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    will-change: transform;
}

.comments-panel::-webkit-scrollbar-button {
    display: none;
}

.comments-panel::-webkit-scrollbar {
    width: 6px;
}

.comments-panel::-webkit-scrollbar-track {
    background: #ffffff14;
    border-radius: 8px;
}

.comments-panel::-webkit-scrollbar-thumb {
    background-color: #ffffff66;
    border-radius: 8px;
}

.comments-panel::-webkit-scrollbar-thumb:hover {
    background-color: #ffffff99;
}

.comments-list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    padding-right: 6px;
}

.comment-time {
    font-size: 12px;
    color: #ffffff80;
}

.comment-body {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.comment-text {
    font-size: 14px;
    color: #ffffff;
    line-height: 1.4;
}

.comment-reply {
    display: flex;
    gap: 8px;
    font-size: 13px;
    color: #FFFFFFCC;
    align-items: flex-start;
    padding: 0.5rem;
    text-align: left;

}

.reply-arrow {
    opacity: 0.7;
    line-height: 1.4;
    color: var(--secondary-font-color);
}


.reply-text {
    line-height: 1.4;
}

.comment-actions {
    display: flex;
    gap: 8px;
}

.comment-actions img {
    width: 16px;
    height: 16px;
    cursor: pointer;
    opacity: 0.85;
    transition: opacity 0.2s ease;
}

.comment-actions img:hover {
    opacity: 1;
}



.comment-actions-bar {
    display: flex;
    position: sticky;
    bottom: 0;
    gap: 12px;
    padding: 16px;
    border-top: 1px solid #ffffff1a;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.comment-card.active {
    border: 1px solid #FFFFFF1F;

}

.comment-card.active .comment-header {
    background: #FFFFFF33;

}

.original-version-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
}

.arrow-btn {
    background: transparent;
    border: none;
    font-size: 18px;
    color: var(--primary-font-color);
    cursor: pointer;
    width: 1.5rem;
}

.arrow-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.primary-btn {
    display: flex;
    flex: 1;
    background: var(--primary-gradient-with-black);
    color: #FFFFFF;
    border-radius: 8px;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    gap: 4px;
}

.primary-btn-image {
    height: 20px;
    width: 20px;
}

.secondary-btn {
    flex: 1;
    background: transparent;
    border: 1px solid #FFFFFF33;
    color: #FFFFFFCC;
    border-radius: 8px;
    padding: 0.5rem;
}

:deep(.highlight-comment) {
    background: #ff780029;
    border-radius: 4px;
    padding: 0 2px;
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;
}

:deep(.highlight-comment.active-comment-highlight) {
    background: pink;
}

:deep(.highlight-comment.active) {
    background: #ff780080;

}

.reply-textarea {
    width: 100%;
    resize: none;
    background: #ffffff14;
    border: 1px solid #ffffff33;
    border-radius: 6px;
    padding: 8px;
    font-size: 13px;
    color: white;
    outline: none;
}

.cancel-img {
    width: 10px;
    height: 10px;
    padding: 2px;
}
</style>